import {useEffect, useState} from "react";
import {categoryStore} from "../../../../Stores/CategoryStore";
import Column from "../../../Common/Column";
import Typography from "@mui/material/Typography";
import {useTheme} from "@mui/material";
import Divider from "../../../Common/Divider";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Space from "../../../Common/Space";
import {StyledSubtleNavigationCrumb} from "../../../BreadCrumbs/Breadcrumbs";
import Row from "../../../Common/Row";
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import useSnackbar from "../../../Snackbar/SnackbarHook";
import {accountStore} from "../../../../Stores/AccountStore";
import {useMediaContext} from "../../../../MediaContext";

const mapCategoriesToList = (tree) => {
    return tree.map(category => ({
        name: category.name,
        id: category.id,
        requiresMitid: category.requiresMitid,
        hasChildren: category.children.length > 0,
    }));
};

export const CategoryList = () => {
    const isMobileSize = useMediaContext().isMobileSize;
    const isTouchInput = useMediaContext().isTouchInput;
    const theme = useTheme();
    const navigate = useNavigate();
    const snackbar = useSnackbar();

    const [items, setItems] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [breadcrumb, setBreadcrumb] = useState(null);

    useEffect(() => {
        let tree = categoryStore.categoryTree;
        let crumbs = [];

        selectedIds?.forEach(id => {
            const category = tree.find(category => category.id === id);

            if (category.children.length === 0) {
                navigate(`/opret-annonce/${category.id}`);
            }

            tree = category.children;
            crumbs = [...crumbs, category.name];
        });

        setItems(mapCategoriesToList(tree));
        setBreadcrumb(crumbs);
    }, [selectedIds]);

    const onSelect = (id) => {
        const item = items.find(item => item.id === id);

        if (item.requiresMitid && !accountStore.user.mitIdValidated) {
            snackbar.handleOpen("Kategorien kræver MitID validering", "error");
            return;
        }

        setSelectedIds(ids => [...ids, id]);
    }

    const onDeselect = () => {
        setSelectedIds(ids => ids.slice(0, -1));
    }

    const onJump = (index) => {
        setSelectedIds(ids => ids.slice(0, index + 1))
    }

    const handleTouchStart = (e) => {
        e.currentTarget.classList.add("highlight");
    };

    const handleTouchEndOrCancel = (e) => {
        e.currentTarget.classList.remove("highlight");
    };

    return (
        <Column sx={{padding: "0 10px 10px 10px", maxWidth: isMobileSize ? "100%" : "400px", marginRight: "50px", boxSizing: "border-box"}}>
            {selectedIds?.length > 0 && <>
                <ArrowBackIcon
                    sx={{cursor: "pointer"}}
                    onClick={onDeselect}
                />
                <Space height="5px"/>
                <Row>
                    {breadcrumb?.map((crumb, index) => {
                        return <StyledSubtleNavigationCrumb
                            key={"breadcrumb-" + index}
                            onClick={() => index > 0 && onJump(index)}
                            sx={{
                                cursor: index === 0 ? "default" : "pointer",
                                "&:hover": index === 0 ? { color: theme.palette.text.secondary } : {},
                            }}
                        >
                            {index > 0 && <>&nbsp;&nbsp;&gt;&nbsp;</>} {crumb}
                        </StyledSubtleNavigationCrumb>
                    })}
                </Row>
                <Space height="15px"/>
            </>}
            {items?.map((item, index) => (
                <Column key={"category-search-item-" + index}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            cursor: "pointer",
                            paddingBottom: "10px",
                            paddingTop: "10px",
                            "&:hover": !isTouchInput && {
                                backgroundColor: theme.palette.action.hover,
                            },
                            "&.highlight": isTouchInput && {
                                backgroundColor: theme.palette.action.hover,
                            },
                        }}
                        onTouchStart={handleTouchStart}
                        onTouchEnd={handleTouchEndOrCancel}
                        onTouchCancel={handleTouchEndOrCancel}
                        onClick={() => onSelect(item.id)}
                    >
                        <Typography>{item.name}</Typography>
                        {item.hasChildren && <Typography>{">"}</Typography>}
                    </Box>
                    <Divider/>
                </Column>
            ))}
        </Column>
    );
}
